export function enableVideoHero()
{
  document.querySelectorAll('.js-videoHero').forEach((hero) =>
  {
    const video = hero.querySelector('video');
    const toggle = hero.querySelector('.js-videoHeroToggle');
    const controls = hero.querySelector('.videoHero__controls');

    if (!video || !toggle)
    {
      return;
    }

    const syncPlaybackState = () =>
    {
      toggle.classList.toggle('is-paused', video.paused);
      toggle.setAttribute(
        'aria-label',
        video.paused ? 'Play background video' : 'Pause background video',
      );
    };

    video.addEventListener('play', syncPlaybackState);
    video.addEventListener('pause', syncPlaybackState);

    toggle.addEventListener('click', () =>
    {
      if (video.paused)
      {
        video.play().catch(syncPlaybackState);
      }
      else
      {
        video.pause();
      }
    });

    const startHeroVideo = () =>
    {
      video.play().catch(() =>
      {
        syncPlaybackState();
      });
    };

    if ('requestIdleCallback' in window)
    {
      requestIdleCallback(startHeroVideo, { timeout: 2000 });
    }
    else
    {
      setTimeout(startHeroVideo, 800);
    }

    controls?.classList.add('is-ready');
    syncPlaybackState();
  });
}
